module.exports = __webpack_public_path__ + "static/media/company-profile-bg2.5120f884.jpg";